<template>
  <div>
      <div v-if="getSaleCostSheet !== null" style="display: flex; flex-direction: column; width: 100%;">
          
          <div 
              style="margin: 10px; padding: 10px; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between; border-bottom: 1px solid #e2e2e2;">
              <span>
                  Fabric Cost ({{getCurrencyFormat.currency_symbol}})
              </span>
                <el-input 
                    @focus="$event.target.select()"
                    size="small"
                    v-model="$store.state.saleMaster.sales_cost_sheet.fabric_cost"
                    style="width: 250px;">
                </el-input>
          </div>

          <div 
              style="margin: 10px; padding: 10px; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between; border-bottom: 1px solid #e2e2e2;">
                <span>
                  Other Material Cost ({{getCurrencyFormat.currency_symbol}})
                </span>
                <el-input 
                    @focus="$event.target.select()"
                    size="small"
                    v-model="$store.state.saleMaster.sales_cost_sheet.material_cost"
                    style="width: 250px;">
                </el-input>
                  
          </div>

          <div 
              style="margin: 10px; padding: 10px; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between; border-bottom: 1px solid #e2e2e2;">
                <span>
                    Piece Rate Worker ({{getCurrencyFormat.currency_symbol}})
                </span>
                <el-input 
                    @focus="$event.target.select()"
                    size="small"
                    v-model="$store.state.saleMaster.sales_cost_sheet.piece_rate_total"
                    style="width: 250px;">
                </el-input>
                  
          </div>

          <div 
              style="margin: 10px; padding: 10px; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between; border-bottom: 1px solid #e2e2e2;">
                <span>
                    Fixed Salary Worker ({{getCurrencyFormat.currency_symbol}})
                </span>
                <el-input 
                    @focus="$event.target.select()"
                    size="small"
                    v-model="$store.state.saleMaster.sales_cost_sheet.fixed_salary_rate"
                    style="width: 250px;">
                </el-input>
          </div>
            <div 
              style="margin: 10px; padding: 10px; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between; border-bottom: 1px solid #e2e2e2;">
                <span>
                    Markup (%)
                </span>
                <el-input 
                    @focus="$event.target.select()"
                    size="small"
                    v-model="$store.state.saleMaster.sales_cost_sheet.markup"
                    style="width: 250px;">
                </el-input>
          </div>
          <div 
              style="margin: 10px; padding: 5px; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between; border-bottom: 1px solid #e2e2e2;">
              <h4>
                  Total Cost ({{getCurrencyFormat.currency_symbol}})
              </h4>
              <h4>
                  {{formatCurrency(getTotalCost)}}
              </h4>
                  
          </div>

          <div 
              style="margin: 5px; padding: 5px; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between; border-bottom: 1px solid #e2e2e2;">
              <h2>
                  Estimated Sales Value ({{getCurrencyFormat.currency_symbol}})
              </h2>
              <h2>
                  {{formatCurrency(getTotalSale)}}
              </h2>
                  
          </div>
          
      </div>
  </div>
</template>

<script>
export default {
    props: ['rowData'],
    computed: {
      getSaleCostSheet() {
        return this.$store.state.saleMaster.sales_cost_sheet
      },
      getTotalCost() {
            let fabric_cost = parseFloat(this.getSaleCostSheet.fabric_cost)
            let piece_rate_total = parseFloat(this.getSaleCostSheet.piece_rate_total)
            let fixed_salary_rate = parseFloat(this.getSaleCostSheet.fixed_salary_rate)
            let material_cost = parseFloat(this.getSaleCostSheet.material_cost)
            let markup = parseFloat(this.getSaleCostSheet.markup)

            return (fabric_cost+piece_rate_total+fixed_salary_rate+material_cost)
      },
      getTotalSale() {
            let fabric_cost = parseFloat(this.getSaleCostSheet.fabric_cost)
            let piece_rate_total = parseFloat(this.getSaleCostSheet.piece_rate_total)
            let fixed_salary_rate = parseFloat(this.getSaleCostSheet.fixed_salary_rate)
            let material_cost = parseFloat(this.getSaleCostSheet.material_cost)
            let markup = parseFloat(this.getSaleCostSheet.markup)

            let total = (fabric_cost+piece_rate_total+fixed_salary_rate+material_cost)
            return (total + ((total*markup)/100))
      }
    },
    mounted() {
        this.$store.state.saleMaster.sales_cost_sheet = null
        setTimeout(() => {
            this.$store.dispatch('fetchCostSheet', {sale_item_id: this.rowData.id})
        }, 1000);
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/SaleMaster/Form/CostSheet/Index.vue